import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { WAITLIST_FLAG_KEY } from "../lib/constants";

export default function Success({ onOpenModal }) {
  const hasAccess = useMemo(() => {
    return localStorage.getItem(WAITLIST_FLAG_KEY) === "true";
  }, []);

  return (
    <div className="successPage">
      <div className="container">
        <div className="successCard">
          <div className="successCard__top">
            <Link className="backLink" to="/">
              ← Back to homepage
            </Link>
          </div>

          {hasAccess ? (
            <>
              <h1 className="successTitle">
                Application Received. Let’s Build. 🏗️
              </h1>

              <div className="successBody">
                <p>We’re reviewing your brand for the next Global Showcase.</p>

                <div className="fundingHook">
                  By joining the waitlist, you are now building your SmartUp
                  Trust Score to unlock access to Global Markets and Funding.
                </div>
                {/*
                <div className="downloadRow">
                  <a
                    className="btn btn--primary"
                    href={PLAYBOOK_URL}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Download: The Global Retail Playbook for Specialty Brand
                    Producers
                  </a>
                </div>   */}

                <div className="nextSteps">
                  <div className="nextSteps__title">What happens next</div>
                  <ul>
                    <li>You’ll receive a confirmation message on-screen</li>
                    <li>Our team will review your application</li>
                    <li>
                      If selected, you’ll be contacted for next steps and
                      onboarding
                    </li>
                  </ul>
                </div>
              </div>
            </>
          ) : (
            <>
              <h1 className="successTitle">Access locked</h1>
              <div className="successBody">
                <p>Please join the waitlist to access the playbook.</p>
                <div className="downloadRow">
                  <button
                    className="btn btn--primary"
                    onClick={() => onOpenModal("success_gate")}
                  >
                    Join the waitlist
                  </button>
                  <Link className="btn btn--secondary" to="/">
                    Return home
                  </Link>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
